import type * as Types from '../../../../../../graphql/generated-base';

import type { DocumentNode } from 'graphql';
import * as Apollo from '@apollo/client';
import * as ApolloReactHooks from '@graphql/react-hooks';
export type EnvelopeTemplatesQueryVariables = Types.Exact<{ [key: string]: never }>;

export type EnvelopeTemplatesQuery = {
  __typename?: 'Query';
  stationeryEnvelopeTemplates: Array<{ __typename?: 'StationeryEnvelopeTemplate'; id: string; themeId: string; themeJSON: any; category: string; side: string }>;
};

export const EnvelopeTemplatesDocument = /*#__PURE__*/ {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'EnvelopeTemplates' },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'stationeryEnvelopeTemplates' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'themeId' } },
                { kind: 'Field', name: { kind: 'Name', value: 'themeJSON' } },
                { kind: 'Field', name: { kind: 'Name', value: 'category' } },
                { kind: 'Field', name: { kind: 'Name', value: 'side' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode;

/**
 * __useEnvelopeTemplatesQuery__
 *
 * To run a query within a React component, call `useEnvelopeTemplatesQuery` and pass it any options that fit your needs.
 * When your component renders, `useEnvelopeTemplatesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useEnvelopeTemplatesQuery({
 *   variables: {
 *   },
 * });
 */
export function useEnvelopeTemplatesQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<EnvelopeTemplatesQuery, EnvelopeTemplatesQueryVariables>) {
  return ApolloReactHooks.useQuery<EnvelopeTemplatesQuery, EnvelopeTemplatesQueryVariables>(EnvelopeTemplatesDocument, baseOptions);
}
export function useEnvelopeTemplatesLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<EnvelopeTemplatesQuery, EnvelopeTemplatesQueryVariables>) {
  return ApolloReactHooks.useLazyQuery<EnvelopeTemplatesQuery, EnvelopeTemplatesQueryVariables>(EnvelopeTemplatesDocument, baseOptions);
}
export type EnvelopeTemplatesQueryHookResult = ReturnType<typeof useEnvelopeTemplatesQuery>;
export type EnvelopeTemplatesLazyQueryHookResult = ReturnType<typeof useEnvelopeTemplatesLazyQuery>;
export type EnvelopeTemplatesQueryResult = Apollo.QueryResult<EnvelopeTemplatesQuery, EnvelopeTemplatesQueryVariables>;
